module.exports = __webpack_public_path__ + "static/media/Right legs19.c6192df5.png";